import { PaletteMode, useMediaQuery } from '@razz-team/ui-web';
import { storedAtom } from '../atoms/storedAtom';
import { computed } from 'nanostores';
import { useSyncExternalStore } from 'react';

export type AppearanceSetting = PaletteMode | 'system';

function parseAppearanceSetting(value: string | null): AppearanceSetting {
  switch (value) {
    case 'light':
    case 'dark':
      return value;
    default:
      return 'system';
  }
}

const $theme = storedAtom('theme');
const $appearance = computed($theme, parseAppearanceSetting);

export function useAppearanceSetting() {
  const appearance = useSyncExternalStore($appearance.subscribe, $appearance.get);

  return [appearance, $theme.set] as const;
}

export function useThemeMode(): PaletteMode {
  const isDark = useMediaQuery<boolean>('(prefers-color-scheme: dark)');
  const [appearance] = useAppearanceSetting();
  return appearance === 'system' ? (isDark ? 'dark' : 'light') : appearance;
}
